<template>
  <div class="daily-repeat">
    <h3 class="title text-gray-700 font-medium">Detail for schedule</h3>
    <day-selection :is-all-day="isAllDay" :repeat="repeatOn"></day-selection>
  </div>
</template>

<script>
import DaySelection from "./DaySelection";
export default {
  components: { DaySelection },
  props: ["isAllDay", "repeatOn"]
};
</script>

<style lang="scss" scoped></style>
